// src/components/profile-components/WalletBalanceCard.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Wallet, Loader2 } from 'lucide-react';
import { getWalletBalance } from '../../services/walletService';
import { convertToPersianNumbers } from '../../utils/PersianNumberUtils';

const WalletBalanceCard = () => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const res = await getWalletBalance();
        setBalance(res.data.balance);
      } catch (err) {
        console.error('Wallet balance fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBalance();
  }, []);

  // تبدیل عدد موجودی به فارسی
  const formattedBalance = balance !== null
    ? convertToPersianNumbers(Number(balance).toLocaleString())
    : '۰';

  return (
    <Link to="/profile/wallet" className="block">
      <div className="bg-white p-3 rounded-xl shadow-lg text-center rtl flex flex-col items-center justify-center cursor-pointer hover:shadow-xl transition-shadow">
        <Wallet size={24} className="text-purple-700 mb-2" />
        {loading ? (
          <Loader2 size={16} className="animate-spin text-purple-700" />
        ) : (
          <span className="text-[10px] font-normal text-gray-800 leading-tight">
            موجودی: {formattedBalance} تومان
          </span>
        )}
      </div>
    </Link>
  );
};

export default WalletBalanceCard;